import { React, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfigSettings } from "../../../../config/Config";
import Iframe from "../../../../components/Iframe";
import { iframeService } from "../../../../services/iFrameService";

export function ProposalsDocuments({ candidateEmail, disabled }) {
  const settings = ConfigSettings();
  const { t } = useTranslation();
  const [proposalUrl, setProposalUrl] = useState();
  const [isAccordionCollapsed, setIsAccordionCollapsed] = useState(true);

  useEffect(() => {
    if (candidateEmail) createIframeUrl();
  }, [candidateEmail]);

  function createIframeUrl() {
    iframeService
      .getProposalByEmail(candidateEmail)
      .then((data) =>
        setProposalUrl(
          `${
            settings.outSystemBaseUrl
          }/Rec_Shared/CandidateProposals?k=${encodeURIComponent(data.key)}`
        )
      );
  }

  async function openProposal(event) {
    let base64res = await fetch(
      `data:application/pdf;base64,${event.data.args[0]}`
    );
    base64res.blob().then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.append(link);
      link.click();
      link.parentNode.removeChild(link);
    });
  }

  const messagehandllers = {
    origin: settings.outSystemBaseUrl,
    open_proposal: openProposal
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingProposal">
        {!disabled ? (
          <button
            className={`accordion-button ${
              isAccordionCollapsed ? "collapsed" : ""
            } disabled-cursor`}
            type="button"
            data-bs-target="#collapseProposal"
            aria-expanded={!isAccordionCollapsed}
            aria-controls="collapseProposal"
            onClick={() =>
              setIsAccordionCollapsed(!isAccordionCollapsed)
            }
          >
            {t("Proposals")}
          </button>
        ) : (
          <label className="accordion-button label-documents">
            {t("Proposals")}
          </label>
        )}
      </h2>

      <div
        id="collapseProposal"
        className={`accordion-collapse ${
          isAccordionCollapsed ? "collapse" : ""
        }`}
        aria-labelledby="headingProposal"
        data-bs-parent="#accordionFlushDocuments"
      >
        <div className="accordion-body margim-table-documents">
          {/*<Iframe url={proposalUrl} messagehandllers={messagehandllers} />*/}

          <div className="dashboard-under-construction">
            <div className="dashboard-under-construction__icon">
              🏗️
            </div>

            <h2>Nova Lista de Propostas está em construção.</h2>

            <p>
              Pedimos desculpa pelo incómodo. Em breve teremos novidades.
            </p>

            <div className="dashboard-under-construction__english">
              <h3>New Proposals List is under construction.</h3>

              <p>
                We apologize for the inconvenience. We will have exciting news
                for you soon.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
